import React,{useState,useEffect} from 'react'

function PayeeTypeAnalytics({transactionItemList}) {
    const [employeePayment,setEmployeePayment] = useState(0);
    const [vendorPayment,setVendorPayment] = useState(0);
    const [otherPayment,setOtherPayment] = useState(0);
    
    
    const prepareTypePayment = () =>{
        if(transactionItemList){
            let _employeePayment = 0;
            let _vendorPayment = 0;
            let _otherPayment = 0;
            transactionItemList.forEach(t => {
                if(t.payeeType==1){
                    _employeePayment = Number(_employeePayment+t.amount);    
                }
                if(t.payeeType==2){
                    _vendorPayment = Number(_vendorPayment+t.amount);    
                }
                if(t.payeeType==11){
                    _otherPayment = Number(_otherPayment+t.amount);    
                }
            });
            setEmployeePayment(_employeePayment);
            setVendorPayment(_vendorPayment);
            setOtherPayment(_otherPayment);
        }
    }
    
    useEffect(()=>{
        prepareTypePayment();
    },[transactionItemList])

    return (
        

        <table className='table table-bordered table-striped'>
            <thead>
                <tr><th colSpan={2}className='text-center table-dark' >Payee Type</th></tr>
                <tr>
                    <th>Pay Type</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Employee</th>
                    <td>{employeePayment}</td>
                </tr>
                <tr>
                    <th>Vendor</th>
                    <td>{vendorPayment}</td>
                </tr>
                <tr>
                    <th>Other</th>
                    <td>{otherPayment}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <td>{Number(employeePayment+vendorPayment+otherPayment)}</td>
                </tr>
            </tfoot>
        </table>
    )
}

export default PayeeTypeAnalytics